import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import { ID_FILTER_CODE, ID_FILTER_NAME, ID_FILTER_TYPOLOGY } from "../../pages/cluster/constants/StoreFilters";
import { ID_FILTER_SEARCH } from "../../pages/cluster/constants/ClustersFilters";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useClusterStoresRepository = () => {
    const { GET, POST, PUT, DELETE } = useApi();

    const PATH = "/finance/cluster-ms"
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);


    function getStores(id: string, offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let code = getFilterValue(ID_FILTER_CODE, filterDefs);
        let name = getFilterValue(ID_FILTER_NAME, filterDefs);
        let type = getFilterValue(ID_FILTER_TYPOLOGY, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            code: code,
            name: name,
            type: type,
            legalEntities: allLegalEntities
        }

        return GET(`${PATH}/${id}/all`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }

    function createStore(idCluster: number, stores: any[], legalEntity: string, dealer: string): Promise<HTTPGenericResponse> {
        let params ={
            clustersMs: stores,
            legalEntity,
            dealer
        }
        return POST(`${PATH}/${idCluster}`, params, {}, true);
    }

    function updateStore(idStore: number, store: any): Promise<HTTPGenericResponse> {
        let params = {
            code: store.code,
            name: store.name,
        }
        return PUT(`${PATH}/${idStore}`, params, {}, true);
    }


    function deleteStore(idStore: number): Promise<HTTPGenericResponse> {
        return DELETE(`${PATH}/${idStore}`, undefined, true)
    }


    return { getStores, createStore, updateStore, deleteStore };
}